import { Post } from "../../types/postTypes"
import { coachesAreEntrepreurs } from "./posts/coachesAreEntrepreneurs"
import { coachesCornerJacquelineWhitmore } from "./posts/coachesCornerJacquelineWhitmore"
import { coachesCornerJessieCruickshank } from "./posts/coachesCornerJessieCruickshank"
import { coachesCornerJoanneWhiteside } from "./posts/coachesCornerJoanneWhiteside"
import { DoYouNeedInsuranceToBeACoach } from "./posts/doYouNeedInsuranceToBeACoach"
import { fourTipsForHolidays } from "./posts/fourTipsForHolidays"
import { howBoundariesAndBreaksCanHelpFightCoachBurnout } from "./posts/howBoundariesAndBreaksCanHelpFightCoachBurnout"
import { howToMarketMyOnlineCoachingBusiness } from "./posts/howToMarketMyOnlineCoachingBusiness"
import { PracticeDoClosing } from "./posts/practicedoclosing"
import { QAWithNicholeLowe } from "./posts/QAWithNichole"
import { readySetGoal } from "./posts/readySetGoal"
import { runASuccessfulOnlineBusiness } from "./posts/runASuccessfulOnlineBusiness"
import { StewardYourInfluenceInBusinessAndLife } from "./posts/stewardYourInfluenceInBusinessAndLife"
import { techstars } from "./posts/techstars"
import { TheGreatestNeedInTheCoachingIndustry } from "./posts/theGreatestNeedInTheCoachingIndustry"
import { TheTopMostProfitableCoachingNiches } from "./posts/topMostProfitableCoachingNiches"
import { TwelveCoachingTipsForTheHolidaySeason } from "./posts/12CoachingTipsForTheHolidaySeason"
import { ventureAtlanta } from "./posts/ventureAtlanta"
import { whatIsZoee } from "./posts/whatIsZoee"
import { WhenYouShouldHireALifeCoach } from "./posts/whenYouShouldHireALifeCoach"
import { WhyEveryEntrepreneurNeedsACoach } from "./posts/whyEveryEntrepreneurNeedsACoach"
import { whyIBuiltTech } from "./posts/whyIBuiltTech"

export const posts: Array<Post> = [
  whyIBuiltTech,
  WhenYouShouldHireALifeCoach,
  DoYouNeedInsuranceToBeACoach,
  TheGreatestNeedInTheCoachingIndustry,
  WhyEveryEntrepreneurNeedsACoach,
  TheTopMostProfitableCoachingNiches,
  whatIsZoee,
  StewardYourInfluenceInBusinessAndLife,
  coachesCornerJacquelineWhitmore,
  howToMarketMyOnlineCoachingBusiness,
  TwelveCoachingTipsForTheHolidaySeason,
  coachesCornerJessieCruickshank,
  runASuccessfulOnlineBusiness,
  fourTipsForHolidays,
  coachesCornerJoanneWhiteside,
  QAWithNicholeLowe,
  howBoundariesAndBreaksCanHelpFightCoachBurnout,
  readySetGoal,
  coachesAreEntrepreurs,
  ventureAtlanta,
  techstars,
  PracticeDoClosing
]
